export const CHECKOUT_COPY_CONFIG = {
  plan_purchase: {
    sections: {
      statCard: {
        title: null,
      },
      title: "Best plans for your workflow", // recommendation
      addOns: { title: "Go further" },
    },
    cart: {
      buyingPlans: {
        title: "Your cart",
      },
      checkoutButton: {
        default: "Checkout",
        resume: "Resume",
        reactivate: "Reactivate",
      },
      promoCode: {
        placeholder: "Enter promo code",
        applyText: "Apply",
      },
      bundleUpgradeBanner: {
        text: `Yay! You just saved {0} All Workflows`,
      },
    },
  },
  plan_manage: {
    sections: {
      statCard: {
        title: null,
      },
      title: "Unlock further potential", //availablePlans
      addOns: { title: "Go further" },
    },
    cart: {
      ownedPlans: {
        title: "Your Plans",
      },

      buyingPlans: {
        title: "Adding To Your Plan",
      },

      checkoutButton: {
        default: "Update Plan",
        resume: "Resume",
        reactivate: "Reactivate",
      },

      promoCode: {
        placeholder: "Enter promo code",
        applyText: "Apply",
      },
    },
  },
  plan_migration: {
    sections: {
      statCard: {
        title: null,
      },
      title: "Available Options", //availablePlans
      addOns: { title: "Go further" },
    },

    cart: {
      ownedPlans: {
        title: "Your Plans",
      },
      buyingPlans: {
        title: "Your Plans",
      },
      checkoutButton: {
        default: "Accept new pricing",
        resume: "Resume",
        reactivate: "Reactivate",
      },
      secondaryButton: {
        default: "Keep current pricing",
      },
      promoCode: {
        placeholder: "Enter promo code",
        applyText: "Apply",
      },
      onRemoveCard: {
        title: "Are you sure you want to downgrade?",
        subtitle:
          "We've made changes to our pricing and features. If you make any changes to your current subscription, you'll need to switch to the new plans.",
        cta: {
          text: "Continue",
        },
      },
      planChangeCard: {
        title: "Aftershoot Subscription Plans Updated",
        subtitle:
          "We have updated our Subscription Plans. Please note, that you're on a Legacy Plan and any changes to it will require you to move onto one of our new plans.",
        cta: {
          text: "Continue",
        },
      },
    },
  },
};
